import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppLocale,
  LOCALE_LABELS,
  SUPPORTED_LOCALES,
  setAppLocale,
} from '../i18n';

export function LanguageSelector() {
  const { t, i18n } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);
  const current = (i18n.resolvedLanguage || i18n.language || 'az').slice(0, 2) as AppLocale;

  useEffect(() => {
    function onDocClick(event: MouseEvent) {
      if (!wrapRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  return (
    <div className="lang-wrap" ref={wrapRef}>
      <button
        type="button"
        className="lang-btn"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t('selectLanguage')}
        onClick={() => setOpen((value) => !value)}
      >
        {current}
      </button>
      {open ? (
        <div className="lang-panel" role="listbox" aria-label={t('language')}>
          {SUPPORTED_LOCALES.map((locale) => (
            <button
              key={locale}
              type="button"
              role="option"
              aria-selected={locale === current}
              className={`lang-option${locale === current ? ' active' : ''}`}
              onClick={() => {
                setAppLocale(locale);
                try {
                  localStorage.setItem('vbbplay.locale_manual', '1');
                } catch {
                  // ignore
                }
                setOpen(false);
              }}
            >
              <span>{LOCALE_LABELS[locale]}</span>
              <code>{locale}</code>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
